import { render, staticRenderFns } from "./home-3.vue?vue&type=template&id=e71605d6&scoped=true&"
import script from "./home-3.vue?vue&type=script&lang=js&"
export * from "./home-3.vue?vue&type=script&lang=js&"
import style0 from "./home-3.vue?vue&type=style&index=0&id=e71605d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e71605d6",
  null
  
)

export default component.exports